module.exports = __webpack_public_path__ + "img/nozzle-logo-white.4ab4a8b.svg";